module.exports = {"421124100":"温泉镇","421124101":"南河镇","421124102":"红山镇","421124103":"金家铺镇","421124104":"石头咀镇","421124105":"草盘地镇","421124106":"雷家店镇","421124107":"杨柳湾镇","421124200":"方家咀乡","421124201":"孔家坊乡","421124202":"陶家河乡","421124400":"桃花冲林场","421124401":"吴家山林场","421124402":"五峰山林场","421124403":"英山县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421124.json
// module id = 1900
// module chunks = 0